import { Mark, mergeAttributes } from '@tiptap/core';

export const BgColor = Mark.create({
  name: 'backgroundColor',

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  addAttributes() {
    return {
      backgroundColor: {
        default: null,
        parseHTML: (element) => element.style.backgroundColor || null,
        renderHTML: (attributes) => {
          if (!attributes.backgroundColor) return {};
          return {
            style: `background-color: ${attributes.backgroundColor}`,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        style: 'background-color',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
      0,
    ];
  },

  //@ts-ignore
  addCommands() {
    return {
      setBgColor:
        (color: string | undefined) =>
        //@ts-ignore
        ({ commands }) => {
          return commands.setMark('backgroundColor', {
            backgroundColor: color,
          });
        },

      unsetBgColor:
        () =>
        //@ts-ignore
        ({ commands }) => {
          return commands.unsetMark('backgroundColor');
        },
      toggleBgColor:
        (color: string) =>
        //@ts-ignore
        ({ commands, state }) => {
          const { from, to } = state.selection;
          let hasColor = false;
          //@ts-ignore
          state.doc.nodesBetween(from, to, (node) => {
            if (
              //@ts-ignore
              node.marks.some((mark) => mark.type.name === 'backgroundColor')
            ) {
              hasColor = true;
            }
          });

          if (hasColor) {
            return commands.unsetMark('backgroundColor');
          } else {
            return commands.setMark('backgroundColor', {
              backgroundColor: color,
            });
          }
        },
    };
  },
});
